import React, { FormEvent, useEffect, useState } from 'react'
import styled from 'styled-components'
import { openAlertModal } from '@app.components/modals/AlertModal'
import { PAGE_SIZE } from '@app.feature/coverletter/coverletter.write/module/constant'
import MagnifyingGlassIcon from 'svgIcons/MagnifyingGlass'
import { useDutyModalStore } from '../../../store/dutyModal'

const ActivitySearch: React.FC = () => {
  const variables = useDutyModalStore((store) => store.variables)
  const setVariables = useDutyModalStore((store) => store.setVariables)

  const [input, setInput] = useState('')

  useEffect(() => {
    if (variables?.filterBy?.query === '') setInput('')
  }, [variables?.filterBy?.query])

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (input && input.trim().length < 2) {
      openAlertModal({
        open: true,
        message: '검색어는 2자 이상 입력하셔야합니다.',
        isModalOverlapping: true,
      })
      return
    }
    setVariables({
      ...variables,
      filterBy: {
        ...variables?.filterBy,
        query: input,
      },
      pagination: {
        page: 1,
        pageSize: PAGE_SIZE,
      },
    })
  }

  return (
    <StyledWrapper onSubmit={handleSubmit}>
      <MagnifyingGlassIcon className="search-icon" />
      <input
        placeholder="회사 또는 직무를 검색하세요"
        value={input}
        onChange={(e) => setInput(e.target.value)}
      />
    </StyledWrapper>
  )
}

export default ActivitySearch

const StyledWrapper = styled.form`
  display: flex;
  align-items: center;
  gap: 5px;
  width: 250px;
  height: 40px;
  padding: 0px 15px;
  border-radius: 8px;
  border: solid 1px #dddddd;

  > input {
    width: 250px;
    height: 100%;
    border: none;
    outline: none;
    &::placeholder {
      font-size: 14px;
      font-weight: 500;
      letter-spacing: -0.56px;
      color: #999999;
    }
  }

  .search-icon {
    width: 18px;
    right: 16px;
  }
`
